import { render, staticRenderFns } from "./addCooperateWine.vue?vue&type=template&id=4934ca0f&scoped=true&"
import script from "./addCooperateWine.vue?vue&type=script&lang=js&"
export * from "./addCooperateWine.vue?vue&type=script&lang=js&"
import style0 from "./addCooperateWine.vue?vue&type=style&index=0&id=4934ca0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4934ca0f",
  null
  
)

export default component.exports